import { render, staticRenderFns } from "./StepperStep.vue?vue&type=template&id=5128d101"
import script from "./StepperStep.vue?vue&type=script&lang=js"
export * from "./StepperStep.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports